import { useCurrentUser } from "../../AuthWrapper2/hooks/useCurrentUser.js";
import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useCurrentUserRegions } from "../../AppWrapper2/hooks/useCurrentUserRegions.js";
import { useRecords } from "./useRecords.js";
import { mergeRecentIds } from "../../../utils/recent-ids/merge-recent-ids.js";
import { useMemo } from "react";
import { keyBy } from "lodash-es";
//#region src/modules/Records/hooks/useRecentRecords.ts
function useRecentRecords() {
	const { userClientMetadata } = useCurrentUser();
	const { currentRegion, scopeAllRegions } = useCurrentUserRegions();
	const { rpcService } = useRPCContext();
	const recentIds = scopeAllRegions ? mergeRecentIds(Object.values(userClientMetadata.regions).map((region) => region?.records?.recentIds)) : currentRegion ? userClientMetadata.regions[currentRegion.id]?.records?.recentIds : void 0;
	const { data, loading, refresh } = useRecords({ idFilter: recentIds || [] });
	const sortedByRecentIds = useMemo(() => {
		if (!data?.records || !recentIds) return null;
		const recordsById = keyBy(data.records, "id");
		return recentIds.map((id) => recordsById[id]).filter((x) => !!x);
	}, [data?.records]);
	const removeRecentRecord = async (recordId) => {
		await rpcService.UserClient.RemoveRecentRecords.v1.call({ recordIds: [recordId] });
		await refresh();
	};
	return {
		loading,
		recentRecords: sortedByRecentIds,
		removeRecentRecord
	};
}
//#endregion
export { useRecentRecords };

//# sourceMappingURL=useRecentRecords.js.map